<template>
  <div>
    <panel-group></panel-group>
    <el-card
      class="container my-5 bg-white"
      :body-style="{ padding: 0 }"
      shadow="hover"
    >
      <div slot="header" class="font-weight-bold text-muted">
        最近7天各项访问量折线图
      </div>
      <line-chart :chart-data="lineChartData"></line-chart>
    </el-card>
    <el-card
      class="container my-5 bg-white"
      :body-style="{ padding: 0 }"
      shadow="hover"
    >
      <div slot="header" class="font-weight-bold text-muted">
        游戏下载量柱状图
      </div>
      <bar-chart></bar-chart>
    </el-card>
  </div>
</template>

<script>
import PanelGroup from "../../components/dashboard/PanelGroup";
import LineChart from "../../components/dashboard/LineChart";
import BarChart from "../../components/dashboard/BarChart";

export default {
  name: "DashBoard",
  components: {
    PanelGroup,
    LineChart,
    BarChart
  },
  data() {
    return {
      lineChartData: {
        totalViews: [],
        androidDownloads: [],
        iosDownloads: [],
        totalDownloads: [],
        newsViews: [],
        jobViews: [],
        nearlySevenDays: []
      }
    };
  },
  mounted() {
    this.getNearlySevenDaysData();
  },
  methods: {
    getNearlySevenDaysData() {
      this.axios.get("/siteLog/nearlySevenDays").then(resp => {
        if (resp && resp.data.code === 10000 && resp.data.success) {
          this.lineChartData = resp.data.data;
        }
      });
    }
  }
};
</script>

<style scoped lang="scss"></style>
